import { useCallback, useEffect, useState } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import api from "../../../../utils/axiosInstance";
import BackButton from "../../../../components/Button/BackButton";
import { btn } from "../../../../components/Button/buttonStyles";
import { toast } from "../../../../components/Toast/toast";import DetailsTab from "./Details/DetailsTab";
import FilesTab from "./Files/FilesTab";
import FinancesTab from "./Finances/FinancesTab";
import TaxesTab from "./Taxes/TaxesTab";

const TABS = ["Details", "Files", "Finances", "Taxes"];

const QuotationDetailPage = () => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "details";

  const [quotation, setQuotation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [drafting, setDrafting] = useState(false);

  const fetchQuotation = useCallback(async () => {
    try {
      const res = await api.get(`/quotations/${id}`);
      setQuotation(res.data.data);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to fetch quotation details");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchQuotation();
  }, [fetchQuotation]);

  const moveToDraft = async () => {
    setDrafting(true);
    try {
      const res = await api.post(`/quotations/${id}/draft`);
      setQuotation(res.data.data);
      toast.success(res.data.message);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to move the quotation to Draft");
    } finally {
      setDrafting(false);
    }
  };

  const locked = Boolean(quotation?.locked);
  const tabProps = { quotationId: id, quotation, locked, onChange: setQuotation };

  return (
    <>
      <div className="border-b mb-6 flex items-end gap-4">
        <BackButton to="/quotations" label={null} className="mb-1.5 -ml-1.5" />
        <div className="h-5 w-px bg-gray-200 mb-2 self-center" />
        <div className="flex space-x-5 overflow-x-auto">
          {TABS.map((tab) => {
            const key = tab.toLowerCase();
            return (
              <button
                key={tab}
                className={`pb-2 text-sm text-gray-600 border-b-2 transition whitespace-nowrap ${
                  activeTab === key
                    ? "border-brand-600 text-brand-600"
                    : "border-transparent hover:text-gray-900 hover:border-gray-300"
                }`}
                onClick={() => setSearchParams({ tab: key })}
              >
                {tab}
              </button>
            );
          })}
        </div>

        {quotation && quotation.status !== "Draft" && (
          <button
            onClick={moveToDraft}
            disabled={drafting}
            className={`${btn("warning", "sm")} ml-auto mb-1.5`}
          >
            {drafting ? "Moving..." : "Draft"}
          </button>
        )}
      </div>

      {loading && (
        <div className="flex justify-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-brand-600" />
        </div>
      )}

      {error && <p className="text-danger-600 text-sm">{error}</p>}

      {quotation && (
        <>
          {activeTab === "details" && <DetailsTab {...tabProps} />}
          {activeTab === "files" && <FilesTab {...tabProps} />}
          {activeTab === "finances" && <FinancesTab {...tabProps} />}
          {activeTab === "taxes" && <TaxesTab {...tabProps} />}
        </>
      )}
    </>
  );
};

export default QuotationDetailPage;